String.prototype.parseURL = function () {
    let path = "", query = "", hash = "", url = this, params;
    if (url.indexOf("#") > 0) {
        hash = url.substring(url.indexOf("#") + 1);
        url = url.substring(0, url.indexOf("#"));
    }
    if (url.indexOf("?") > 0) {
        path = url.substring(0, url.indexOf("?"));
        query = url.substring(url.indexOf("?") + 1);
        params = query.split('&');
    } else
        path = url;
    return {
        getHost: function () {
            let hostexp = /\/\/([\w.-]*)/;
            let match = hostexp.exec(path);
            if (match != null && match.length > 1)
                return match[1];
            return "";
        },
        getPath: function () {
            let pathexp = /\/\/[\w.-]*(?:\/([^?]*))/;
            let match = pathexp.exec(path);
            if (match != null && match.length > 1)
                return match[1];
            return "";
        },
        getHash: function () {
            return hash;
        },
        getParams: function () {
            return params
        },
        getQuery: function () {
            return query;
        },
        setHash: function (value) {
            if (query.length > 0)
                query = "?" + query;
            if (value.length > 0)
                query = query + "#" + value;
            return path + query;
        },
        setParam: function (name, value) {
            if (!params) {
                params = new Array();
            }
            params.push(name + '=' + value);
            for (let i = 0; i < params.length; i++) {
                if (query.length > 0)
                    query += "&";
                query += params[i];
            }
            if (query.length > 0)
                query = "?" + query;
            if (hash.length > 0)
                query = query + "#" + hash;
            return path + query;
        },
        insertParam: function (name, value, index) {
            if (!params) {
                params = new Array();
            }

            let newParam = name + '=' + value;

            if (index <= 0)
                params.unshift(newParam);
            else if (index >= params.length)
                params.push(newParam);
            else
                params.splice(index, 0, name + '=' + value);

            query = "";
            for (let i = 0; i < params.length; i++) {
                if (query.length > 0)
                    query += "&";
                query += params[i];
            }
            if (query.length > 0)
                query = "?" + query;
            if (hash.length > 0)
                query = query + "#" + hash;
            return path + query;
        },
        getParam: function (name) {
            if (params) {
                for (let i = 0; i < params.length; i++) {
                    let pair = params[i].split('=');
                    if (decodeURIComponent(pair[0]) == name)
                        return decodeURIComponent(pair[1]);
                }
            }
            console.log('Query variable %s not found', name);
        },
        hasParam: function (name) {
            if (params) {
                for (let i = 0; i < params.length; i++) {
                    let pair = params[i].split('=');
                    if (decodeURIComponent(pair[0]) == name)
                        return true;
                }
            }
            console.log('Query variable %s not found', name);
        },
        removeParam: function (name) {
            query = "";
            if (params) {
                let newparams = new Array();
                for (let i = 0; i < params.length; i++) {
                    let pair = params[i].split('=');
                    if (decodeURIComponent(pair[0]) != name)
                        newparams.push(params[i]);
                }
                params = newparams;
                for (let i = 0; i < params.length; i++) {
                    if (query.length > 0)
                        query += "&";
                    query += params[i];
                }
            }
            if (query.length > 0)
                query = "?" + query;
            if (hash.length > 0)
                query = query + "#" + hash;
            return path + query;
        },
        deduplicateParams: function (order = 'FIFO') {
            query = "";
            if (params) {
                let newparams = new Array();
                if (order.toLowerCase() === 'lifo') {
                    for (let i = params.length - 1; i >= 0; i--) {
                        let pair = params[i].split('=');
                        if (!newparams.find(p => p.startsWith(pair[0] + '=')))
                            newparams.push(params[i]);
                    }
                }
                if (order.toLowerCase() === 'fifo') {
                    for (let i = 0; i < params.length; i++) {
                        let pair = params[i].split('=');
                        if (!newparams.find(p => p.startsWith(pair[0] + '=')))
                            newparams.push(params[i]);
                    }
                }
                params = newparams;
                for (let i = 0; i < params.length; i++) {
                    if (query.length > 0)
                        query += "&";
                    query += params[i];
                }
                if (query.length > 0)
                    query = "?" + query;
                if (hash.length > 0)
                    query = query + "#" + hash;
                return path + query;
            }
        },
        reconstitute: function () {
            return `https://${this.getHost()}/${this.getPath()}${this.getQuery()}`;
        }
    }
}

String.prototype.Cleanse = function () {
    return this.replace(/[^\w\.@!? ,/:+()'´_#*-]/gi, " ");
}

String.prototype.isNullOrWhitespace = function () {
    if (!this)
        return true;
    if (typeof this === 'string') {
        let trimmed = this.trim();
        let len = trimmed.length;
        if (len == 0)
            return true;
        else
            return false;
    }

    return false;
}